export default (oldData) => {
	const newData = oldData.map(({id, customGroupRender: groupLabel, items, name}) => ({
		id,
		groupLabel,
		data: items.map((item) => ({...item, id: `${id}_${item.engId}`})),
		name
	}));

	return newData;
};
